mutation CreateHifo($hifoInput: HifoChangeInput!) {
  createHifo(input: { hifoInput: $hifoInput }) {
    hifo {
      id
    }
  }
}
